'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

var _Chart = require('../charts/Chart');

var _Chart2 = _interopRequireDefault(_Chart);

var _Table = require('../charts/Table');

var _Table2 = _interopRequireDefault(_Table);

var _KeyFigure = require('../charts/KeyFigure');

var _KeyFigure2 = _interopRequireDefault(_KeyFigure);

var _helpers = require('../charts/helpers');

var _displayTools = require('../../utils/display-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MakerChart = function (_React$Component) {
	_inherits(MakerChart, _React$Component);

	function MakerChart(props) {
		_classCallCheck(this, MakerChart);

		var _this = _possibleConstructorReturn(this, (MakerChart.__proto__ || Object.getPrototypeOf(MakerChart)).call(this, props));

		_this.state = {
			chartData: false
		};
		_this.renderChart = _this._renderChart.bind(_this);
		_this.loadData = _this._loadData.bind(_this);
		_this.chartAttributes = _this._chartAttributes.bind(_this);
		_this.shouldGetData = _this._shouldGetData.bind(_this);
		_this.triggerGetData = _this._triggerGetData.bind(_this);
		_this.renderTextGuide = _this.renderTextGuide.bind(_this);
		_this.validateOptions = _this.validateOptions.bind(_this);
		_this.renderDataError = _this.renderDataError.bind(_this);

		return _this;
	}

	_createClass(MakerChart, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.triggerGetData(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.triggerGetData(nextProps);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props$data = this.props.data,
			    dataPoints = _props$data.dataPoints,
			    groupBy = _props$data.groupBy,
			    filters = _props$data.filters,
			    title = _props$data.title,
			    description = _props$data.description,
			    orderBy = _props$data.orderBy;


			var columnsString = dataPoints ? dataPoints.map(_displayTools.formatTitle).join(', ') : null;
			var groupByString = groupBy ? groupBy.map(_displayTools.formatTitle).join(', ') : null;

			var filterString = filters ? filters.map(function (filter) {
				return filter.label;
			}).join(', ') : null;

			return _react2.default.createElement(
				'div',
				{ className: 'chart-wrapper' },
				title && _react2.default.createElement(
					'h2',
					null,
					title
				),
				description && _react2.default.createElement(
					'div',
					{ className: 'description' },
					description
				),
				this.renderChart(),
				_react2.default.createElement(
					'div',
					{ className: 'definition' },
					columnsString && groupByString && _react2.default.createElement(
						'span',
						null,
						'Showing ',
						_react2.default.createElement(
							'span',
							{ className: 'columns' },
							columnsString
						),
						', grouped by ',
						_react2.default.createElement(
							'span',
							{ className: 'grouped-by' },
							groupByString
						),
						'.',
						_react2.default.createElement('br', null)
					),
					filterString && _react2.default.createElement(
						'span',
						null,
						'Filtered by ',
						_react2.default.createElement(
							'span',
							{ className: 'filters' },
							filterString
						),
						'.'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)("loading", { show: this.state.loadingData || !this.validateOptions() }) },
					_react2.default.createElement(
						'div',
						{ className: 'loading-content' },
						this.state.loadingData && _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement('i', { className: 'fa fa-spin fa-fw fa-circle-o-notch' }),
							' Loading Data...'
						),
						_react2.default.createElement('br', null),
						this.renderTextGuide()
					)
				),
				this.renderDataError()
			);
		}
	}, {
		key: 'renderTextGuide',
		value: function renderTextGuide() {
			var _props$data2 = this.props.data,
			    dataPoints = _props$data2.dataPoints,
			    groupBy = _props$data2.groupBy,
			    filters = _props$data2.filters,
			    chartType = _props$data2.chartType;


			var list = _react2.default.createElement(
				'ol',
				{ className: 'options-checklist' },
				_react2.default.createElement(
					'li',
					{ className: (0, _classnames2.default)({ done: chartType }) },
					'Select the type of chart you wish to make.'
				),
				_react2.default.createElement(
					'li',
					{ className: (0, _classnames2.default)({ done: dataPoints.length }) },
					'Select one or more data points under "I want to see" to get started.'
				),
				chartType !== 'key-figure' && _react2.default.createElement(
					'li',
					{ className: (0, _classnames2.default)({ done: groupBy.length }) },
					'Select one or more fields to group the data by.'
				),
				this.hasFiltersWithoutValues(filters) && _react2.default.createElement(
					'li',
					null,
					'Make sure each of your filters has a value or remove the filter.'
				)
			);

			return list;
		}
	}, {
		key: 'hasFiltersWithoutValues',
		value: function hasFiltersWithoutValues(filters) {
			for (var i = 0; i < filters.length; i++) {
				if (filters[i].values.length === 0) return true;
			}
			return false;
		}
	}, {
		key: 'validateOptions',
		value: function validateOptions() {
			var _props$data3 = this.props.data,
			    dataPoints = _props$data3.dataPoints,
			    groupBy = _props$data3.groupBy,
			    filters = _props$data3.filters,
			    chartType = _props$data3.chartType;


			if (!chartType || !groupBy.length || !dataPoints.length || this.hasFiltersWithoutValues(filters)) {
				return false;
			}

			return true;
		}
	}, {
		key: '_renderChart',
		value: function _renderChart() {

			var returnElems = [];
			if (this.state.chartData !== false) {
				var key = this._chartAttributes(this.props);
				if (this.props.data.chartType === 'table') {
					returnElems.push(_react2.default.createElement(_Table2.default, {
						key: key,
						data: this.state.chartData
					}));
				} else if (this.props.data.chartType === 'key-figure') {

					returnElems.push(_react2.default.createElement(_KeyFigure2.default, {
						key: key,
						data: this.state.chartData,
						filters: this.props.data.filters
					}));
				} else {
					returnElems.push(_react2.default.createElement(_Chart2.default, {
						key: key,
						data: this.state.chartData,
						type: this.props.data.chartType
					}));
				}
			}

			return returnElems;
		}
	}, {
		key: 'renderDataError',
		value: function renderDataError() {
			if (!this.state.chartData || !this.state.chartData.error) return null;

			return _react2.default.createElement(
				'div',
				{ className: 'data-error' },
				_react2.default.createElement(
					'div',
					{ className: 'data-error-container' },
					_react2.default.createElement(
						'h2',
						null,
						'Data Error'
					),
					_react2.default.createElement(
						'p',
						null,
						this.state.chartData.error
					)
				)
			);
		}
	}, {
		key: '_loadData',
		value: function _loadData() {

			var that = this;
			var component = this.props.data;
			var url = location.origin + '/ajax/chartData';

			if (!this.validateOptions()) return;

			that.setState({
				loadingData: true
			});

			_request2.default.get({
				url: url,
				qs: component,
				headers: {
					'X-CSRF-TOKEN': CSRF_TOKEN,
					'Content-Type': 'application/json'
				}
			}, function (err, r, body) {

				if (err) console.log(err);

				if (r.statusCode > 299) return;

				if (that.props.data.chartType === 'table' || that.props.data.chartType === 'key-figure') {
					var data = JSON.parse(body);
				} else {
					var data = (0, _helpers.transformData)(JSON.parse(body), component);
				}

				that.setState({
					chartData: data,
					loadingData: false
				});
			});
		}
	}, {
		key: '_chartAttributes',
		value: function _chartAttributes(props) {
			var _props$data4 = props.data,
			    dataPoints = _props$data4.dataPoints,
			    groupBy = _props$data4.groupBy,
			    filters = _props$data4.filters,
			    chartType = _props$data4.chartType,
			    orderBy = _props$data4.orderBy;

			return JSON.stringify({ dataPoints: dataPoints, groupBy: groupBy, filters: filters, chartType: chartType, orderBy: orderBy });
		}
	}, {
		key: '_shouldGetData',
		value: function _shouldGetData(newProps) {

			if (!newProps.data.dataPoints) return false;
			if (!newProps.data.groupBy) return false;
			if (!newProps.data.chartType) return false;

			var chartAttributes = this.chartAttributes(newProps);

			// console.log(this.state.chartAttributes + "\n" + chartAttributes);

			return this.state.chartAttributes !== chartAttributes;
		}
	}, {
		key: '_triggerGetData',
		value: function _triggerGetData(newProps) {
			var _this2 = this;

			var props = newProps ? newProps : this.props;

			if (this.shouldGetData(props)) {
				var chartAttributes = this.chartAttributes(props);
				this.setState({
					chartAttributes: chartAttributes
				}, function () {
					_this2.loadData();
				});
			}
		}
	}]);

	return MakerChart;
}(_react2.default.Component);

exports.default = MakerChart;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/maker/MakerChart.js
// module id = 580
// module chunks = 0